import { render, staticRenderFns } from "./ResearchQuestion.vue?vue&type=template&id=12e9d39a&scoped=true&"
import script from "./ResearchQuestion.vue?vue&type=script&lang=js&"
export * from "./ResearchQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ResearchQuestion.vue?vue&type=style&index=0&id=12e9d39a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e9d39a",
  null
  
)

export default component.exports